module.exports = __webpack_public_path__ + "static/media/astellas.14d16102.png";